module.exports = __webpack_public_path__ + "static/media/trivia-home.bb351c14.png";